import { useAuthStore } from "@stores/auth";

export const IfHasPermission = (permission) => {
  const permissions = useAuthStore((state) => state.permissions);
  return permissions?.some((item) => item.name === permission);
};

export const IfHasRole = (role) => {
  const user = useAuthStore((state) => state.user);
  return user?.role?.name === role;
};

export const IfHasRoleByLocalStorage = (role) => {
  try {
    const authData = localStorage.getItem("persist:atcplus-auth");
    if (!authData) return false;

    const parsedData = JSON.parse(authData);
    return parsedData?.roleName?.replaceAll('"', "") === role;
  } catch (error) {
    console.warn("Error parsing localStorage auth data:", error);
    return false;
  }
};

export const GetUser = () => {
  const auth = useAuthStore((state) => ({
    user: state.user,
    authToken: state.authToken,
    permissions: state.permissions,
    roleName: state.roleName,
  }));
  return auth;
};
